<template></template>
<script>
export default {
  name: "APIDoc",
  data() {
    return {};
  },
  mounted() {
    //  query: {
    //     redirect: _this.$route.query.redirect,
    //   },
    window.location.href = "/user-login?redirect=" + this.$route.query.redirect;
  },
};
</script>
<style >
.page-container {
  font-size: 25px;
  text-align: center;
  color: rgb(192, 204, 218);
}
</style>
